module.exports = __webpack_public_path__ + "img/MURALE_WAVE.90fe5fb7.jpg";